export { SplashScreen } from './SplashScreen'
